
import { CheckSession } from '@/actions/userActions.js'
import {
    GetRequestedRoute,
    HasAuthMarker,
    MarkSessionAuthenticated,
    RedirectToLogin
} from '@/helpers/authRedirectHelpers.js'

export default async function Auth({ next, to }) {
    const code = to.query._reqUzcode

    if(code){
        const hasSession = await CheckSession()
        if(hasSession){
            const requestedRoute = GetRequestedRoute(to.path)
            MarkSessionAuthenticated()
            return next(requestedRoute)
        }

        RedirectToLogin(GetRequestedRoute(to.path))
        return
    }

    if(!HasAuthMarker() || !await CheckSession()){
        RedirectToLogin(to.fullPath)
        return
    }

    return next()
}
